import { h } from "preact";
import usePromoBanner from "./usePromoBanner";
import styles from "./promoBanner.module.css";
import { iconClose } from "../../assets";
import PromoBannerTimer from "./PromoBannerTimer";
import PromoBannerPromoRow from "./PromoBannerPromoRow";
import PromoBannerPriceRow from "./PromoBannerPriceRow";

function PromoBanner({ onClose, onVisibilityChange }) {
    const {
        time,
        handleClose,
        handleCopy,
        copied,
        bannerData,
        isRendered,
        hasPrice,
        hasSpecialPrice,
    } = usePromoBanner({ onClose, onVisibilityChange });

    if (!isRendered) return null;

    const {
        type,
        productName,
        productHref,
        discountText,
        coupon,
        secondaryText,
        price,
        specialPrice,
        colors,
    } = bannerData;

    // CSS custom properties derived from API colors. Applied to .banner so all
    // descendants can consume them via var(--promo-*).
    const bannerVars = {
        "--promo-base": colors.base,
        "--promo-secondary": colors.secondaryText,
        "--promo-primary-text": colors.primaryText,
        "--promo-close-bg": colors.closeIcon,
        "--promo-bg": colors.background,
    };

    // Alert type: no coupon to copy, the whole banner surface redirects to productHref.
    // Coupon type: has a coupon — individual links remain so the CTA is the copy action.
    const isAlertType = !coupon && !!productHref;
    const isSpecialPriceLayout = hasPrice && hasSpecialPrice;

    const productNameElement = productHref && !isAlertType ? (
        <a href={productHref} className={styles.productName}>{productName}</a>
    ) : (
        <span className={styles.productName}>{productName}</span>
    );

    return (
        <div
            className={`font-museo ${styles.wrapper} ${coupon ? styles.wrapperCoupon : ""} ${isSpecialPriceLayout ? styles.wrapperSpecialPrice : ""}`}
            style={{ backgroundColor: colors.background }}
            data-offer-type={type}
        >
            <div className={styles.banner} style={bannerVars}>
                {isAlertType && (
                    <a
                        href={productHref}
                        className={styles.bannerLink}
                        aria-label={productName}
                    />
                )}

                <div className={styles.content}>
                    <div className={styles.leftBlock}>
                        <div className={styles.textGroup}>
                            {productNameElement}

                            {!isSpecialPriceLayout && (
                                <PromoBannerPromoRow
                                    className={styles.promoRow}
                                    discountText={discountText}
                                    productHref={productHref}
                                    isAlertType={isAlertType}
                                    coupon={coupon}
                                    copied={copied}
                                    onCopy={handleCopy}
                                    secondaryText={secondaryText}
                                />
                            )}

                            <PromoBannerPriceRow
                                isSpecialPriceLayout={isSpecialPriceLayout}
                                price={price}
                                specialPrice={specialPrice}
                            />
                        </div>
                    </div>

                    <div className={styles.rightBlock}>
                        <PromoBannerTimer className={styles.timer} time={time} />

                        <button
                            type="button"
                            aria-label="Fechar banner promocional"
                            className={styles.closeButton}
                            onClick={handleClose}
                        >
                            <img src={iconClose} alt="" className={styles.closeIcon} />
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PromoBanner;
